import { action } from 'satcheljs';
/**
 * Launches PopupOpen Action
 */
export default action('POPUP_OPENED', function () {
    return {
        isOpen: true,
    };
});
//# sourceMappingURL=popupOpened.js.map